import React from 'react';

interface IconCardProps {
    icon: React.ReactNode;
    label: string;
}

export default function IconCard({ icon, label }: IconCardProps) {
    return (
        <div className="flex flex-col w-[calc(82*var(--vh-unit))] h-[calc(82*var(--vh-unit))] widescreen:h-[calc(104*var(--vh-unit))] widescreen:w-[calc(180*var(--vw-unit))] items-center justify-center gap-[calc(10*var(--vh-unit))]">
            <div className="flex items-center justify-center w-[calc(54*var(--vw-unit))] h-[calc(54*var(--vh-unit))] widescreen:h-[calc(80*var(--vh-unit))] widescreen:w-[calc(104*var(--vw-unit))]">
                {icon}
            </div>
            <p className="text-center text-[calc(14*var(--vh-unit))] leading-[calc(18*var(--vh-unit))] font-normal tracking-[calc(-0.28*var(--vh-unit))] text-[color:var(--color-text-sub01)] widescreen:text-[calc(16*var(--vh-unit))] widescreen:font-medium widescreen:leading-[calc(20*var(--vh-unit))] widescreen:tracking-[calc(-0.32*var(--vh-unit))]">
                {label}
            </p>
        </div>
    );
}
